/**
 * サーバー名に対応するギリシャ文字のマッピング
 */
const GREEK_MAP: Record<string, string> = {
  アルファ: "α",
  ベータ: "β",
  ガンマ: "γ",
  デルタ: "δ",
  イプシロン: "ε",
  ゼータ: "ζ",
  イータ: "η",
  シータ: "θ",
  イオタ: "ι",
  カッパ: "κ",
  ラムダ: "λ",
  ミュー: "μ",
  ニュー: "ν",
  クサイ: "ξ",
  オミクロン: "ο",
  パイ: "π",
  ロー: "ρ",
  シグマ: "σ",
  タウ: "τ",
  ユプシロン: "υ",
  ファイ: "φ",
  カイ: "χ",
  プサイ: "ψ",
  オメガ: "ω",
};

/**
 * サーバー名がギリシャ文字（流星サーバー特有 of 名称）かどうかを判定します。
 */
export function isGreekName(name: string): boolean {
  return name in GREEK_MAP;
}

/**
 * サーバー名とタイプに基づいたモックアイコンのURLを取得します。
 * 流星サーバー(type 1)かつギリシャ文字名の場合は、ローカルの専用画像を使用します。
 * それ以外は ui-avatars.com を使用した動的生成を行います。
 *
 * @param name サーバー名
 * @param type サーバータイプ (0: サテライト, 1: 流星)
 * @returns モックアイコンのURL
 */
export function getMockIconUrl(name: string, type: number): string {
  // 流星サーバー特有のギリシャ文字名称の場合
  if (type === 1 && isGreekName(name)) {
    // 日本語のファイル名を安全にURLに含めるためにエンコード
    const fileName = encodeURIComponent(`meteor_${name}.png`);
    return `${import.meta.env.BASE_URL}images/mock/${fileName}`;
  }

  // それ以外（サテライトサーバーのフォールバックや、ギリシャ文字以外の流星サーバー）
  const char = name.charAt(0);
  const bg = type === 1 ? "1e3a8a" : "3b82f6";
  const color = "ffffff";
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(char)}&background=${bg}&color=${color}&size=128&font-size=0.6&bold=true`;
}

